import React from 'react';
import {ConsumerProvider} from "../../context/ConsumerContext";
import WizardFlow from "./WizardFlow";

function ConsumerHome() {

    return (
        <ConsumerProvider>
            <WizardFlow/>
        </ConsumerProvider>
    )

}

export default ConsumerHome;
